/**
 * Enum representing the type of app
 */
export enum AppType {
    GUARD = 'guard',
    CLIENT = 'client'
}
